import { createPaginatedResponseSchema } from 'api/common-schemas';
import { z } from 'zod';

export const RequestSupportSchema = z.object({
  subject: z.string().nonempty('Required'),
  contact_email: z.string().email().nonempty('Required'),
  contact_phone_number: z.string().nonempty('Required'),
  company_name: z.string().nullish().optional().or(z.literal('')),
  description: z.string().nonempty('Required').max(1000, 'Max 1000 characters'),
  priority: z.enum(['Low', 'Medium', 'High']),
});

export type RequestSupportFormType = z.infer<typeof RequestSupportSchema>;

export const SupportRequestItemSchema = z.object({
  id: z.string(),
  case_number: z.string(),
  subject: z.string(),
  status: z.string(), // e.g. "Open"
  priority: z.enum(['Low', 'Medium', 'High']),
  ticket_type: z.string(), // e.g. "New Customer Request"

  account_name: z.string().nullable().optional(),
  additional_emails: z.string().nullable().optional(),
  assigned_to: z.string().nullable().optional(),
  billing_account_id: z.string().nullable().optional(),
  comments: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  disputed_amount: z.any().nullable().optional(),
  escalated_request: z.boolean().optional(),
  issue: z.string().nullable().optional(),
  last_modified_by: z.string().nullable().optional(),
  last_updated: z.string(),
  latest_case_comment: z.string().nullable().optional(),
  opened: z.string(),
  opened_by: z.string().nullable().optional(),
  premier_rep: z.string().nullable().optional(),
  premier_team: z.string().nullable().optional(),
  service_account_id: z.string().nullable().optional(),
  source: z.string().nullable().optional(),
  sub_reason: z.string().nullable().optional(),
  supplied_email: z.string().nullable().optional(),
  supplied_name: z.string().nullable().optional(),
});

export type SupportRequestItem = z.infer<typeof SupportRequestItemSchema>;

export const SupportRequestsResponseSchema = createPaginatedResponseSchema(
  SupportRequestItemSchema,
);

export type SupportRequestsResponse = z.infer<
  typeof SupportRequestsResponseSchema
>;

export type SupportRequestsQuery = {
  page?: number; // default 1
  page_size?: number; // default 10
  statuses?: string[]; // e.g. ["Open"]
  types?: string[]; // e.g. ["New Customer Request"]
  created_dates?: string[]; // "YYYY-MM-DD"
  search?: string;
  sort?:
    | 'last_updated:desc'
    | 'last_updated:asc'
    | 'opened:desc'
    | 'opened:asc';
};

export const SupportRequestsFilterSearchParamsSchema = z
  .object({
    page: z.coerce.number().min(1).default(1),
    page_size: z.coerce.number().min(1).max(100).default(10),
    status: z.string().optional(),
    type: z.string().optional(),
    opened_by: z.string().optional(),
    date_range: z.string().optional(),
    sort_by: z.string(),
    sort_order: z.string(),
  })
  .partial();

export type SupportRequestsFilterSearchParams = z.infer<
  typeof SupportRequestsFilterSearchParamsSchema
>;
